import { SPage } from "servisofts-component";
import Model from "../../../Model/";
import tbemp from "./tbemp";
export default SPage.combinePages("profile", {
    // "": root,
    tbemp

})
